import { render, staticRenderFns } from "./ContractSign.vue?vue&type=template&id=b0d45d70&"
import script from "./ContractSign.vue?vue&type=script&lang=js&"
export * from "./ContractSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0d45d70')) {
      api.createRecord('b0d45d70', component.options)
    } else {
      api.reload('b0d45d70', component.options)
    }
    module.hot.accept("./ContractSign.vue?vue&type=template&id=b0d45d70&", function () {
      api.rerender('b0d45d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/contracts/ContractSign.vue"
export default component.exports